class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    this.syncSearchOverlayTop();
    requestAnimationFrame(this.syncSearchOverlayTop.bind(this));
    this.onSearchOverlayResize =
      this.onSearchOverlayResize || this.syncSearchOverlayTop.bind(this);
    window.addEventListener('resize', this.onSearchOverlayResize);

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if (this.onSearchOverlayResize) {
      window.removeEventListener('resize', this.onSearchOverlayResize);
    }
    document.documentElement.style.removeProperty('--facett-search-dim-top');
  }

  syncSearchOverlayTop() {
    var header = document.getElementById('shopify-section-header');
    var bottom = header ? header.getBoundingClientRect().bottom : 0;
    document.documentElement.style.setProperty(
      '--facett-search-dim-top',
      Math.max(0, Math.round(bottom)) + 'px'
    );
  }
}

customElements.define('details-modal', DetailsModal);
